import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Modal, Typography, IconButton, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import {
  allotVehicle,
  clearGetAvailableSuplliers,
  clearGetAvailableVehicle,
  getAvailableSuplliers,
  getAvailableVehicle,
} from 'redux/actions/OperationsAction';
import { getReservationDetails } from 'redux/actions/reservationAction';
import { debounce } from 'lodash';
import {
  getDateFormat,
  getReservationDetailsObject,
  getTimeFormat,
} from 'utils/utils';
import Loader from 'components/loader/Loader';
import SearchBar from 'components/commonSearch/SearchBar';
import AllotingVehicleTable from './AllotingVehicleTable';
import ReasonModal from 'components/reasonModal/ReasonModal';

const AllotVehicleModal = ({ open, toggle, tripDetails, page, payload }) => {

  const dispatch = useDispatch();
  const [tabSelect, setTabSelect] = useState('myVehicles');
  const [search, setSearch] = useState('');
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedVehicleForAssign, setSelectedVehicleForAssign] = useState(null);

  useEffect(() => {
    if (tripDetails?.id) {
      if (page === 'listPage' || page === 'allot' || page === 'Reservation') {
        dispatch(getReservationDetails(tripDetails?.id));
      }

      if (open) {
        dispatch(getAvailableVehicle(tripDetails?.id));
      }
    }
  }, [open]);

  useEffect(() => {
    return () => {
      dispatch(clearGetAvailableSuplliers());
      dispatch(clearGetAvailableVehicle());
    };
  }, []);

  const restripDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  //---Time Format---
  const handleTimeFormat = (date) => {
    return getTimeFormat(date);
  };

  const reservationDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );

  const details = getReservationDetailsObject(reservationDetails);

  const myvehicleList = useSelector(
    (state) => state?.getAvailableVehicle?.availableVehicle?.data
  );
  const myvehicleListLoader = useSelector(
    (state) => state?.getAvailableVehicle?.loading
  );
  const mySupplierList = useSelector(
    (state) => state?.availableSuppliers?.availableSuppliers?.data
  );
  const mySupplierListLoader = useSelector(
    (state) => state?.availableSuppliers?.loading
  );

  const AllRidesModalTableData = {
    ID: reservationDetails?.tripId || 'NA',
    Status: reservationDetails?.status || 'NA',
    'Start Date': reservationDetails?.scheduledTime
      ? handleDateFormating(reservationDetails?.scheduledTime)
      : 'NA',
    'End Date': details?.tripEndTime
      ? handleDateFormating(details?.tripEndTime)
      : 'NA',
    'Reporting time': reservationDetails?.scheduledTime
      ? handleTimeFormat(reservationDetails?.scheduledTime)
      : 'NA',
      City: restripDetails?.ServiceCity?.name || 'NA',
    'Duty Type': reservationDetails?.dutyTypeName || 'NA',
    'Vehicle Group': reservationDetails?.MasterCarType?.carType || 'NA',
  };

  const handleChange = (event, newValue) => {
    setTabSelect(newValue);
    setSearch('');
    if (newValue === 'myVehicles') {
      dispatch(getAvailableVehicle(tripDetails?.id));
    } else {
      dispatch(getAvailableSuplliers(tripDetails?.id));
    }
  };

  // UPDATE THIS FUNCTION
  const handleClose = () => {
    toggle();
    setTabSelect('myVehicles');
    setSearch('');
    setShowReasonModal(false);
    setSelectedVehicleForAssign(null); 
  };

  const filterData = (data) => {
    if (data[0] !== 'Duty Type' && data[0] !== 'Vehicle Group') {
      return true;
    } else {
      return false;
    }
  };

  const handleAllot = (vehicleDetails) => {
    setSelectedVehicleForAssign(vehicleDetails);
    
    // Check if this is a reassign (status is 'alloted') or an upgrade scenario
    const isReassign = reservationDetails?.status.toLowerCase() === 'alloted';
    const isUpgrade = vehicleDetails?.Vehicle?.carTypeId !== reservationDetails?.carTypeId;
    
    if (isReassign || isUpgrade) {
      // Show reason modal for reassign or upgrade
      setShowReasonModal(true);
    } else {
      // Assign without upgrade - call API directly without reason
      const data = {
        tripId: tripDetails?.id,
        driverId: vehicleDetails?.Vehicle?.driverId,
      };
      dispatch(allotVehicle(data, page, payload));
      handleClose();
      setSearch('');
    }
  };

  const handleReasonSubmit = (reasonData) => {
    // Call API with reason and comments
    const data = {
      tripId: tripDetails?.id,
      driverId: selectedVehicleForAssign?.Vehicle?.driverId,
      reason: reasonData.reason,
      comments: reasonData.comments,
    };
    dispatch(allotVehicle(data, page, payload));
    handleClose();
    setSearch('');
  };

  const handleBackFromReasonModal = () => {
    setShowReasonModal(false);
    setSelectedVehicleForAssign(null);
  };

  const isUpgradeScenario = () => {
    if (!selectedVehicleForAssign || !reservationDetails) return false;
    return selectedVehicleForAssign?.Vehicle?.carTypeId !== reservationDetails?.carTypeId;
  };

  const getAssignType = () => {
    return reservationDetails?.status.toLowerCase() === 'alloted' ? 'reassign' : 'assign';
  };

  const onSearch = debounce((e) => {
    setSearch(e);
    const searchFilterData = {
      id: tripDetails?.id,
      search: e,
    };
    if (tabSelect === 'myVehicles') {
      dispatch(getAvailableVehicle(searchFilterData));
    } else {
      dispatch(getAvailableSuplliers(searchFilterData));
    }
  }, 500);

  return (
    <>
      <Modal
        open={open && !showReasonModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="customModal"
        onClose={handleClose}
      >
        <Box
          className="modalContent allotModalContent textLeft"
          sx={{ height: { xs: 'fit-content', sm: 'auto' } }}
        >
          <Box className="allotModalContentWrapper">
            <Box className="closeIcon justifyBetween">
              <Typography
                variant="head3"
                component={'h1'}
                className="colorPrimary fw600 mb10"
              >
                Duty Allotment
              </Typography>
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>

            {reservationDetails?.id ? (
              <Grid container className="mt30 mb20 borderSolidGrey">
                {Object.entries(AllRidesModalTableData)
                  .filter((element) => filterData(element))
                  .map((key) => (
                    <Grid key={key} item xs={12} md={6} container>
                      <Grid
                        xs={4}
                        md={6}
                        item
                        className="p10 alignStart borderSolidGrey pl25"
                      >
                        <Typography variant={'body2'} className="colorGrey">
                          {key[0]}
                        </Typography>
                      </Grid>
                      <Grid
                        xs={8}
                        md={6}
                        item
                        className="p10 alignStart borderSolidGrey pl25"
                      >
                        <Typography variant={'body2'}>{key[1]}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                {Object.entries(AllRidesModalTableData)
                  .filter((element) => {
                    if (
                      element[0] === 'Duty Type' ||
                      element[0] === 'Vehicle Group'
                    ) {
                      return true;
                    }
                    return false;
                  })
                  .map((key) => (
                    <Grid key={key} item xs={12} container>
                      <Grid
                        xs={4}
                        md={3}
                        item
                        className="alignStart borderSolidGrey pl25"
                      >
                        <Typography variant={'body2'} className="colorGrey">
                          {key[0]}
                        </Typography>
                      </Grid>
                      <Grid
                        xs={8}
                        md={9}
                        item
                        className="alignStart borderSolidGrey pl25 p10"
                      >
                        <Typography variant={'body2'}>{key[1]}</Typography>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
            ) : (
              <Loader height="40vh" />
            )}

            <TabContext value={tabSelect.toString()}>
              <Grid
                container
                className="tabBoxStyle justifyBetween flexColumn pl40"
              >
                <Grid item justifyContent={'center'} container>
                  <TabList
                    className="minHeight32"
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label="My Vehicles"
                      value="myVehicles"
                      className="tabStyle colorGrey"
                    />
                    <Tab
                      label="My Suppliers"
                      value="mySuppliers"
                      className="tabStyle colorGrey"
                    />
                  </TabList>
                </Grid>
              </Grid>
              <TabPanel value="myVehicles">
                <>
                <SearchBar
                  onSearchQuery={onSearch}
                  search={search}
                />
                {myvehicleListLoader ? (
                  <Loader height="15vh" />
                ) : (
                    <div className="mt20">
                    <AllotingVehicleTable
                      myvehicleList={myvehicleList}
                      handleAllot={handleAllot}
                      tab={tabSelect}
                    />
                    </div>
                )}
                </>
              </TabPanel>
              <TabPanel value="mySuppliers">
              <>
                <SearchBar
                  onSearchQuery={onSearch}
                  search={search}
                />
                {mySupplierListLoader ? (
                  <Loader height="15vh" />
                ) : (
                  <div className="mt20">
                  <AllotingVehicleTable
                    myvehicleList={mySupplierList}
                    handleAllot={handleAllot}
                    tab={tabSelect}
                  />
                  </div>
                )}
                 </>
              </TabPanel>
            </TabContext>
          </Box>
        </Box>
      </Modal>

      <ReasonModal
        open={showReasonModal}
        onClose={() => {
          setShowReasonModal(false);
          setSelectedVehicleForAssign(null);
        }}
        onBack={handleBackFromReasonModal}
        onSubmit={handleReasonSubmit}
        assignType={getAssignType()}
        isUpgrade={isUpgradeScenario()}
        selectedVehicle={selectedVehicleForAssign}
        tripDetails={reservationDetails}
      />
    </>
  );
};

export default AllotVehicleModal;